module.exports = __webpack_public_path__ + "img/referal-exams-2.4854ed72.svg";